import CompanyInfoDto from '../companyInfo/CompanyInfoDto';
import { AccountSolution } from '../jwt/JWT';
import UserDto from '../user/UserDto';

export enum AccountExtType {
  HOUSEHOLD = 'HOUSEHOLD',
  BUSINESS = 'BUSINESS',
}

export default interface CompanyDto {
  id: number;
  name: string;
  domain: string | null;
  parentId: number | null;
  solution: AccountSolution | null;
  users: UserDto[];
  contactRef: string | null;
  accountRef: string | null;
  accountExtNumber: string | null;
  accountExtType: AccountExtType | null;
  childCompaniesNames: string[];
  zoneId: string;
  companyInfo?: CompanyInfoDto | null;
}
